<template>
  <el-row>
    <el-col :span="24">
      <el-card shadow="none"
               class="userinfo-main bt-border4">
        <div slot="header">个人资料</div>
        <el-row class="main">
          <el-col :xs="24"
                  :span="18">
            <el-form ref="userInfoForm"
                     label-position="top"
                     :model="userInfo"
                     :rules="rules"
                     label-width="90px">
              <el-form-item label="上传用户头像"
                            class="alignCenter"
                            prop="picture">
                <el-upload class="avatar-uploader"
                           accept=".jpg, .jpeg, .png"
                           :action="imgUpUrl"
                           :headers="{ token: authId }"
                           :show-file-list="false"
                           :on-success="handleAvatarSuccess"
                           :before-upload="beforeAvatarUpload">
                  <img v-if="userInfo.picture"
                       :src="imgDownUrl + userInfo.picture"
                       class="avatar" />
                  <i v-else
                     class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="用户名："
                            prop="username">
                <el-input disabled
                          v-model="userInfo.username"
                          placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item label="手机号："
                            prop="mobile">
                <el-input v-model="userInfo.mobile"
                          placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item label="原密码："
                            prop="password">
                <el-input type="password"
                          v-model="userInfo.password"
                          placeholder="请输入原密码"></el-input>
              </el-form-item>
              <el-form-item label="新密码："
                            prop="new_password">
                <el-input type="password"
                          v-model="userInfo.new_password"
                          placeholder="请输入新密码"></el-input>
              </el-form-item>
              <p class="item-title">密保问题</p>
              <el-form-item label="您的生日："
                            prop="answer1">
                <el-input type="password"
                          v-model="userInfo.answer1"
                          placeholder="请输入您的生日"></el-input>
              </el-form-item>
              <el-form-item label="您父亲的姓名："
                            prop="answer2">
                <el-input type="password"
                          v-model="userInfo.answer2"
                          placeholder="请输入您父亲的姓名"></el-input>
              </el-form-item>
              <el-form-item label="您母亲的姓名："
                            prop="answer3">
                <el-input type="password"
                          v-model="userInfo.answer3"
                          placeholder="请输入您母亲的姓名"></el-input>
              </el-form-item>
              <el-form-item class="alignCenter">
                <el-button v-has="'/user/self'"
                           type="primary"
                           @click="handleSave('userInfoForm')">确 定
                </el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
// import validate from '@/common/validate'
export default {
  data() {
    return {
      imgUpUrl: fetch.uploadImgUrl,
      imgDownUrl: fetch.downImgUrl,
      authId: localStorage.getItem('token'),
      userInfo: {
        picture: '',
        username: '',
        mobile: '',
        password: '',
        new_password: '',
        answer1: '',
        answer2: '',
        answer3: ''
      },
      rules: {
        password: [{ required: true, message: '请输入原密码' }],
        answer1: [{ required: true, message: '请输入您的生日' }],
        answer2: [{ required: true, message: '请输入您父亲的姓名' }],
        answer3: [{ required: true, message: '请输入您母亲的姓名' }]
        // mobile: [
        //   { required: true, message: '请输入手机号' },
        //   { validator: validate.tel, trigger: 'blur' }
        // ]
      }
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getUserInfo({ id: localStorage.getItem('uId') }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.userInfo = data
            this.userInfo.password = ''
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    beforeAvatarUpload(file) {
      const isLt500K = file.size / 1024 < 500
      if (!isLt500K) {
        this.$message.error('上传头像图片大小不能超过 500K!')
      }
      return isLt500K
    },
    handleAvatarSuccess(res) {
      this.userInfo.picture = res.result.file_url
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.setUserInfo({ ...this.userInfo }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$refs[formName].resetFields()
                this.$alert('修改成功！', '提示', {
                  confirmButtonText: '确定',
                  callback: () => {}
                })
                localStorage.setItem('avatar', this.userInfo.picture)
                localStorage.setItem('username', this.userInfo.username)
                this.getInfo()
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">
.userinfo-main {
  .main {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .avatar-uploader .el-upload {
    border-radius: 50% !important;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: block;
  }
}
</style>
